import { useTranslation } from 'react-i18next'
import './style.scss'
import { useState } from 'react';
import { BackButton, MainButton, useWebApp } from '@vkruglikov/react-telegram-web-app';
import SettingsApi from '@/features/Settings/api'
import { useParams } from 'react-router-dom';
import { useErrorBoundary } from 'react-error-boundary';
import useEnvInitData from '@/hooks/useEnvInitData'
import Alert from "@/components/Alert";

export default function Captcha({ data, setData, back }) {
	const { raffle_id } = useParams();
	const { t } = useTranslation()
	const [value, setValue] = useState(data.captcha ?? false)
	const WebApp = useWebApp();
	const [saving, setSaving] = useState(false)
	const { showBoundary } = useErrorBoundary()
	const [InitDataUnsafe, InitData] = useEnvInitData();
	const [alert, showAlert] = useState(false)

	const handleSave = () => {
		if (saving) return;
		setSaving(true);

		SettingsApi.captchaSave({
			initData: InitData,
			raffle: raffle_id,
			value: value,
		}).then(function(result) {
			if (result.result) {
				showAlert(true)
				setTimeout(() => {
					showAlert(false)
				}, 3500)
			}
		}).catch((e) => {
			showBoundary(e)
		}).finally(() => {
			setSaving(false)
			setData(prev => ({
				...prev,
				captcha: value
			}));
		})
	}

	return (
		<div className='Captcha'>
			<BackButton onClick={back} />
			<div className={'Captcha__switcher' + (value ? ' Captcha__switcher--active' : '')}>
				<b>{value ? t('features.settings.shield.captcha.disable') : t('features.settings.shield.captcha.enable')}</b>
				<button type='button' onClick={() => setValue(!value)}><span></span></button>
			</div>
			<div className='boxText'>
				<div className='boxText_body'>
					{value ? <p>{t('features.settings.shield.captcha.text')}</p> : null}
					<p><b>{t('features.settings.shield.captcha.info')}</b></p>
				</div>
			</div>
			{!data.is_vip ?
				<div className='boxText'>
					<div className='boxText_body'>
						<p>{ t('features.settings.vip_text') }</p>
						<button
							className='btn btn--block btn--light btn--tt-none'
							onClick={() => {
								WebApp.openTelegramLink(process.env.REACT_APP_LINK_TO_BOT + '?start=vip-clear')
								WebApp.close()
							}}
						>
							{ t('features.settings.vip_btn') }
						</button>
					</div>
				</div>
			:
				<MainButton
					className='btn btn--block'
					onClick={handleSave}
					disabled={saving}
					progress={saving}
					text={t('features.settings.shield.captcha.save')}
				/>
			}
			{alert && <Alert>{t('features.settings.shield.text_save')}</Alert>}
		</div>
	)
}
